import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { css } from 'aphrodite/no-important';
import { styles } from '../styles/SuccessModalStyles';
import { getQueryString } from '../../shared/utils';
import { assetsDomain, getOrderedChannels } from '../../shared/utils';

const headline = "Thanks for Activating!";
const desc = "Your TV subscription allows you full access to our content.";
const storeKey = "mvpd_modal_displayed";
const timeout = 10000;

class SuccessModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            display: this.getModalLocalStorage(),
            channels: this.props.channels,
        }
        this.wisReg = window.wisRegistration;
        this.close = this.close.bind(this);
    }
    componentDidMount() {
        if(this.state.display) {
            document.body.classList.add('screen-lock');
            this.setModalLocalStorage();
            this.startCloseTimer();
        }
    }
    componentWillUnmount(){
        clearInterval(this.timer);
    }
    startCloseTimer() {
        this.timer = setTimeout(() => {
            this.close();
        }, timeout)
    }
    close() {
        this.setState({display: false})
        document.body.classList.remove('screen-lock');
    }
    setModalLocalStorage() {
        window.localStorage.setItem(storeKey, true);
    }
    getModalLocalStorage() {
        return window.localStorage.getItem(storeKey) !== "true" && getQueryString('source') === 'nav'; 
    }
    isMvpdLoggedIn(){
        if(typeof this.wisReg.isUserLoggedInMVPD === "function"){
           return this.wisReg.isUserLoggedInMVPD();
        }
        return false;
    }
    render() {
        const channels = this.state.channels;
        if(!this.state.display) return null;
        return (
            <div className={css(styles.mvpdContent)}>
                <div className={css(styles.mvpdWrapper)}>
                    <span className={css(styles.mpvdContentTitle)}> {headline} </span>
                    <span className={css(styles.mpvdContentDesc)}> {desc} </span>
                    <div className={css(styles.authedChannels)}> 
                        { channels && channels.map((channel, index) => {
                            return  ( 
                                <Fragment>
                                    <div className={css(styles.authedChannel)}>
                                        <figure className={css(styles.marg)}>
                                            <img className={css(styles.channelImg)} alt={ channel.name } key={index} src={`${assetsDomain}images/${channel.name}.svg`}/>
                                        </figure>
                                        <span className={css(styles.iCheckMark)}></span>
                                    </div> 
                                </Fragment> 
                            )
                        }) }
                    </div>
                    <button className={css(styles.btnClose)} onClick={this.close}> <span className={css(styles.close)}> </span> </button>
                </div>
            </div>
        );

    }

}

let mvpdModal = document.getElementsByTagName('MVPDModal');
mvpdModal = mvpdModal.length > 0 && mvpdModal[0];

const wisReg = window.wisRegistration;
if(wisReg && mvpdModal) { 
    const isLoggedInMVPD = wisReg.isUserLoggedInMVPD();
    if(isLoggedInMVPD) {
        wisReg.getUserEntitlements().then( res => {
            if(res && res.channels) {
                const channels = getOrderedChannels(res.channels);
                ReactDOM.render(<SuccessModal channels={channels}></SuccessModal>, mvpdModal);
            }
        });
    }
};
